import { IonCol, IonGrid, IonInfiniteScroll, IonInfiniteScrollContent, IonRow } from '@ionic/react';
import { ComponentProps, useEffect, useState } from 'react';

// Components
import { ReportListCard } from '@/components/Cards';
// Styles
import styles from '@/components/ReportList/index.module.css';

// Types
import { ExportedClient, ReportInfo, ReportInfoDict } from '@/models';

interface ReportCardListProps extends Omit<ComponentProps<typeof IonGrid>, 'class'> {
  data: ReportInfoDict;
  searchResult: ReportInfo[];
}

export const ReportCardList = ({ data, searchResult }: ReportCardListProps) => {
  const [visibleCardCount, setVisibleCardCount] = useState(10); // Initial number of cards
  const cardsToLoad = 10; // Number of cards to load when scrolling to the end

  const generateItems = () => {
    setVisibleCardCount((prevCount) => prevCount + cardsToLoad);
  };

  // const [visibleCardCount, setVisibleCardCount] = useState(2); // Initial number of cards
  // const cardsToLoad = 10; // Number of cards to load when scrolling to the end

  // // const shouldLoadMore = useMemo(() => visibleCardCount < list.length, [visibleCardCount, list]);

  useEffect(() => {
    console.log('generating items');
    generateItems();

    return () => {
      setVisibleCardCount(10);
    };
  }, []);

  return (
    <IonGrid className={styles.grid}>
      <IonRow className={styles.row}>
        {data && (
          <>
            {searchResult.slice(0, visibleCardCount).map((reportInfo) => {
              return (
                <IonCol key={reportInfo.id} size='12' size-md='6'>
                  <ReportListCard
                    date={reportInfo.uploadTimestamp}
                    id={reportInfo.id ?? ''}
                    key={reportInfo.id}
                    majorVersion={reportInfo.version?.col0}
                    name={reportInfo.reportName}
                    reportInfo={reportInfo}
                    reportType={reportInfo.reportType}
                    tags={reportInfo.tags}
                  />
                </IonCol>
              );
            })}
          </>
        )}
      </IonRow>
      <IonRow>
        <IonInfiniteScroll
          onIonInfinite={(ev) => {
            generateItems();
            setTimeout(() => ev.target.complete(), 500);
          }}>
          <IonInfiniteScrollContent></IonInfiniteScrollContent>
        </IonInfiniteScroll>
      </IonRow>
    </IonGrid>
  );
};
